function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 55,
  r: 49
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M35 55h40"
});

var SvgCircleMinus = function SvgCircleMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "plus-minus",
    viewBox: "0 0 110 110"
  }, props), _ref, _ref2);
};

export default SvgCircleMinus;